module.exports = __webpack_public_path__ + "img/documents-sub.fbca4844.svg";